module.exports = __webpack_public_path__ + "files/Plattegrond Brielle hotel.d24059eb.pdf";